import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../environments/environment';
import { AccessService } from '../services/access/access.service';

const AUTHORIZATION = 'Authorization';
const ABSOLUTE_URL = /^(https?:)?\/\//i;
const LOCAL_ASSET = /^\/?assets\//i;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const accessService = inject(AccessService);

  const url = toApiUrl(req.url);

  if (req.headers.has(AUTHORIZATION)) {
    return next(req.clone({ url }));
  }

  const jwt = accessService.getJWT();
  return next(
    jwt ? req.clone({ url, setHeaders: { [AUTHORIZATION]: `Bearer ${jwt}` } }) : req.clone({ url })
  );
};

function toApiUrl(url: string): string {
  return ABSOLUTE_URL.test(url) || LOCAL_ASSET.test(url) ? url : environment.apiUrl + url;
}
